import { lazy } from "react";

export interface TemplateDefinition {
  templateKey: string;
  name: string;
  description: string;
  component: React.ComponentType<any>;
}

export class TemplateLoader {
  private static templates: Map<string, TemplateDefinition> = new Map();

  static {
    // 標準テンプレートの登録
    this.registerTemplate({
      templateKey: "general",
      name: "General",
      description: "Standard template for general use",
      component: lazy(() =>
        import("../presentation/templates/general/general-app-container")
      ),
    });

    this.registerTemplate({
      templateKey: "monotone",
      name: "Monotone",
      description: "Minimalist monochrome template",
      component: lazy(() =>
        import("../presentation/templates/monotone/monotone-app-container")
      ),
    });

    // カスタムデザインの登録
    this.registerTemplate({
      templateKey: "minpaku",
      name: "Minpaku",
      description: "Custom design for Minpaku",
      component: lazy(() =>
        import("../presentation/custom-design/minpaku/minpaku-app-container")
      ),
    });
  }

  static registerTemplate(template: TemplateDefinition): void {
    this.templates.set(template.templateKey, template);
  }

  static getTemplate(templateKey: string): TemplateDefinition | undefined {
    return this.templates.get(templateKey);
  }

  static getAvailableTemplates(): TemplateDefinition[] {
    return Array.from(this.templates.values());
  }

  static getDefaultTemplate(): TemplateDefinition {
    return this.getTemplate("general") || this.getAvailableTemplates()[0];
  }
}

export default TemplateLoader;
